export default __webpack_public_path__ + "static/router_w.34a765bcc62948d8dc744f2d38625bc7.png";